import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = []

  connect() {
    window.addEventListener("scroll", this.handleScroll.bind(this))
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll.bind(this))
  }

  handleScroll = () => {
    const scrolled = window.scrollY > 50
    
    this.element.classList.toggle("bg-brand-600", scrolled)
    this.element.classList.toggle("py-5", !scrolled)
    this.element.classList.toggle("py-2", scrolled)    
  }
}
